module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
 var fontService = require('FontService').default;
 var listService = require('ListService').default;

    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 nopadding-r\">\r\n        <select name=\"fontFamily\" class=\"style-font\"  id=\"fontFamily\">\r\n           \r\n        </select> \r\n    </div>\r\n \r\n    <div class=\"col-md-6 subsection nopadding-r\">\r\n        <div style=\"text-align: right; margin-right: 14px;\"> \r\n            <select name=\"fontSize\" id=\"fontSize\" class=\"style-font\" >\r\n                ")
    ;  fontService.getFontSizes().forEach(function(size) { 
    ; __append("\r\n                    <option value=\"")
    ; __append(escapeFn(size))
    ; __append("\">")
    ; __append(escapeFn(size))
    ; __append("</option>\r\n                ")
    ;  }); 
    ; __append("\r\n                <option></option>\r\n            </select> \r\n        </div>\r\n    </div> \r\n</div>\r\n")
    ;  if(listService.accountSettings.UseSystemFont === "True"){ 
    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"col-md-6 subsection nopadding-r\">\r\n        <div>\r\n            <div id=\"main_text_font_family_custom\">\r\n                <input id=\"customFontFamily\" style=\"margin-bottom:2px;\" name=\"customFontFamily\" type=\"text\" value=\"")
    ; __append(escapeFn( customFontFamily ))
    ; __append("\" ")
    ; __append(escapeFn( customFontFamilyDisabled ))
    ; __append("/>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n")
    ;  } 
    ; __append("\r\n\r\n")
  }
  return __output;

}